import { FunctionComponent, useContext, useEffect, useState } from 'react'
import { ReportPeriodContext } from '../context/report-periods/report-periods'
import { useNavigate } from 'react-router-dom'

export const useReportPeriodWatcher: FunctionComponent<{ redirectUrl: string }> = ({ redirectUrl }) => {
  const navigate = useNavigate()
  const reportPeriodContext = useContext(ReportPeriodContext)
  const [initialCurrentReportPeriodId, setInitialCurrentReportPeriodId] = useState<string>()
  const [isRendered, setIsRendered] = useState<boolean>(false)

  useEffect(() => {
    if (isRendered && reportPeriodContext.lastSelectedReportId !== initialCurrentReportPeriodId) {
      navigate(redirectUrl)
    } else if (reportPeriodContext.lastSelectedReportId) {
      setInitialCurrentReportPeriodId(reportPeriodContext.lastSelectedReportId)
      setIsRendered(true)
    }
  }, [reportPeriodContext.lastSelectedReportId])

  return null
}